import { useTranslation } from 'next-i18next';
import React from 'react';

import { NextImage, Typography } from '@/shared/components/atoms';

const CustomOperationHeader: React.FC<{
  type: 'variety' | 'operation';
  cropName?: string | null;
  cropImage?: string | null;
}> = ({ cropName, cropImage, type }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='flex items-center gap-4 ltr:pr-2 rtl:pl-2'>
        <Typography weight='bold'>
          {t(
            type === 'variety'
              ? 'create-custom-variety'
              : 'add-custom-operation'
          )}
        </Typography>
        {cropImage && cropName && (
          <Typography weight='bold' className='flex items-center'>
            (
            <NextImage src={cropImage} width={16} height={16} alt={cropName} />
            {`${cropName})`}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default CustomOperationHeader;
